<template>
    <Transition name="fade" duration="100">
        <Teleport to=".card" v-if="props.floating">
            <slot></slot>
        </Teleport>
        <slot v-else></slot>
    </Transition>
</template>

<script setup>
import { defineProps } from 'vue'

const props = defineProps({
    floating: {
        type: Boolean,
        default: false
    }
})
</script>